import { guideSteps } from '@/mocks/comic';

export default function Guide() {
  return (
    <section id="guide" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-800">
            追更指南
          </span>
          <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
            三步搞定高效追更
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-600">
            从打开目录到新章直达，漫蛙漫画让每次追更都干净利落。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((step, idx) => (
            <div
              key={step.title}
              className="relative rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <span className="absolute right-5 top-4 font-heading text-5xl font-black text-background-200">
                {String(idx + 1).padStart(2, '0')}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}